module.exports = __webpack_public_path__ + "img/proyecto3.f5803cde.png";